import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("coa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function getHome() {
  const { data } = await http.get("/home");
  return data;
}
export async function getStats() {
  const { data } = await http.get("/stats");
  return data;
}
export async function listContent(ctype, params = {}) {
  const { data } = await http.get(`/content/${ctype}`, { params });
  return data;
}
export async function getContent(ctype, slug) {
  const { data } = await http.get(`/content/${ctype}/${slug}`);
  return data;
}
export async function getMapCases() {
  const { data } = await http.get("/map/cases");
  return data;
}
export async function getMapNews() {
  const { data } = await http.get("/map/news");
  return data;
}
export async function uploadMedia(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await http.post("/admin/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
export async function search(q) {
  const { data } = await http.get("/search", { params: { q } });
  return data;
}

// SSE streaming for the AI archivist.
export async function streamAsk(question, sessionId, onDelta, onDone, onError) {
  try {
    const res = await fetch(`${API}/ai/ask`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ question, session_id: sessionId }),
    });
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let sid = sessionId;
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n\n");
      buffer = lines.pop();
      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed.startsWith("data:")) continue;
        const payload = JSON.parse(trimmed.slice(5).trim());
        if (payload.session_id) sid = payload.session_id;
        if (payload.delta) onDelta(payload.delta);
        if (payload.error) onError && onError(payload.error);
        if (payload.done) onDone && onDone(sid);
      }
    }
    onDone && onDone(sid);
  } catch (e) {
    onError && onError(e.message);
  }
}
